module.exports = __webpack_public_path__ + "static/new_engagement_models_expanded-0f6c9f045b39b6d29d3aa4c78233daf7.svg";